export default "__VITE_ASSET__38f3e1b6__"